import React from 'react';
import { Popover } from 'ui-components/popover/popover';

const StatusTag = ({
  status, tooltip }:  
  { status: string, tooltip: string }) => {
  return (
    <div className="xgs-site__content-container__preview">
      <span className="xgs-site__content-container__preview__text">{status}</span>
      <Popover values={<div className="xgs-site__content-container__preview__tooltip">
        {tooltip}</div>} />
    </div>
  );
}

export default StatusTag;
